import BuyTicketTemplate from './buy-ticket.html';
import BuyTicketController from './buy-ticket.controller';

function routeConfig($stateProvider) {
	'ngInject';

	$stateProvider
		.state('app.public.btms.buy-ticket', {
			url: '/buy-ticket?ticketId&ticketPrice',
			template: BuyTicketTemplate,
			controller: BuyTicketController,
			controllerAs: 'vm',
			// 'params': {
			// 	'ticketPrice': ''
			// },
			'resolve': {
				'Ticket': function(TicketComponent, $stateParams) {
					'ngInject';

					return TicketComponent.showTicket($stateParams.ticketId);
				},
				'EpayButton': function(PaymentComponent, $stateParams, $location) {
					'ngInject';

					const urls = {
						'url_cancel': `${ $location.protocol() }://${ $location.host() }`,
						'url_ok': `${ $location.protocol() }://${ $location.host() }/payment-ready`
					};

					return PaymentComponent.fetchPaymentButton($stateParams.ticketId, urls);
				}
			}
		});
}

export default routeConfig;



/** WEBPACK FOOTER **
 ** ./client/public/main/buy-ticket/buy-ticket.route.js
 **/